// src/api.js
import axios from 'axios';

// 创建 axios 实例
const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL, // 从环境变量获取基础 URL
    timeout: 10000, // 请求超时时间
});

// 请求拦截器
apiClient.interceptors.request.use(
    (config) => {
        // 在请求发送之前可以添加一些公共逻辑，例如添加 token
        // const token = localStorage.getItem('token');
        // if (token) {
        //   config.headers['Authorization'] = `Bearer ${token}`;
        // }
        return config;
    },
    (error) => {
        // 处理请求错误
        return Promise.reject(error);
    }
);

// 响应拦截器
apiClient.interceptors.response.use(
    (response) => {
        // 对响应数据进行处理，例如返回数据格式化
        return response.data; // 直接返回数据部分
    },
    (error) => {
        // 处理响应错误
        console.error('API Error:', error.response || error.message);
        return Promise.reject(error);
    }
);

// 封装 GET 请求
export const get = (url, params = {}) => {
    return apiClient.get(url, { params });
};

// 封装 POST 请求
export const post = (url, data) => {
    return apiClient.post(url, data);
};

// 其他请求类型可以继续封装
export const put = (url, data) => {
    return apiClient.put(url, data);
};

export const del = (url) => {
    return apiClient.delete(url);
};

// 封装的 API 示例
// export const getSeller = () => get('/seller');
// export const createOrder = (data) => post('/order', data);


